import React from 'react';

import { FIRE_CLASS_OPTIONS } from '@vlabs/api-bindings/src/luna-client/constants';
import { FireIcon } from '@vlabs/icons';
import { calculateProbabilityPercent } from '@vlabs/monokit/shared/lib/utils';
import { Tag } from '@vlabs/uikit';
import { useTranslation } from 'react-i18next';

import { BaseVideoAnalyticsDetails } from '../components/BaseVideoAnalyticsDetails';
import type { AnalyticDetailsEvent } from '../types';

type FireEvent = AnalyticDetailsEvent & {
  event: AnalyticDetailsEvent['event'] & {
    fire_class?: keyof typeof FIRE_CLASS_OPTIONS;
    fire_score?: number;
  };
};

export function FireDetails({ event }: { event: FireEvent }): React.JSX.Element {
  const { t } = useTranslation();
  const score = calculateProbabilityPercent(event.event.fire_score);
  const fireClassLabel = event.event.fire_class
    ? FIRE_CLASS_OPTIONS[event.event.fire_class]?.label
    : undefined;

  return (
    <BaseVideoAnalyticsDetails
      event={event}
      tags={(
        <React.Fragment>
          {!!fireClassLabel && (
            <Tag
              data-testid="workspace.analyticEventDetails.tagType"
              kind="neutral"
              size="large"
              value={fireClassLabel}
            />
          )}

          <Tag
            data-testid="workspace.analyticEventDetails.extraTagType"
            icon={<FireIcon />}
            kind="neutral"
            size="large"
            value={`${t('videoAnalytics:fireAnalyticDetails.workspace.tag.label')} ${score}%`}
          />
        </React.Fragment>
      )}
      title={t('videoAnalytics:fireAnalyticDetails.workspace.title')}
    />
  );
}
